 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML02_COPYRIGHT from '@/components/html/02_Copyright'
 import HTML01_TITLE_PAGE from '@/components/html/01_Title_Page'
 import HTML03_CONTENTS from '@/components/html/03_Contents'
 import HTML03_BY_WAY_OF_INTRODUCTION from '@/components/html/03_By_way_of_introduction'
 import HTML04_NO_ONE_CAN_SAY_WHAT_QUANTUM_MECH from '@/components/html/04_No_one_can_say_what_quantum_mech'
 import HTML05_QUANTUM_MECHANICS_IS_NOT_REALLY from '@/components/html/05_Quantum_mechanics_is_not_really'
 import HTML06_QUANTUM_OBJECTS_ARE_PARTICLE__BU from '@/components/html/06_Quantum_objects_are_particle__bu'
 import HTML07_QUANTUM_PARTICLES_AREN_T__BUT_SO from '@/components/html/07_Quantum_particles_aren_t__but_so'
 import HTML08_WHAT__HAPPENS__DEPENDS_ON_WHAT_W from '@/components/html/08_What__happens__depends_on_what_w'
 import HTML09_THERE_ARE_MANY_WAYS_OF_THEORY__A from '@/components/html/09_There_are_many_ways_of_theory__a'
 import HTML10_WHATEVER_THE_QUESTION__THE_ANSWE from '@/components/html/10_Whatever_the_question__the_answe'
 import HTML11_NOT_EVERYTHING_IS_KNOWABLE_AT_ON from '@/components/html/11_Not_everything_is_knowable_at_on'
 import HTML12_THE_PROPERTIES_OF_QUANTUM_OBJECT from '@/components/html/12_The_properties_of_quantum_object'
 import HTML13_THERE_IS_NO__SPOOKY_ACTION_AT_A from '@/components/html/13_There_is_no__spooky_action_at_a'
 import HTML14_THE_EVERYDAY_WORLD_IS_WHAT_QUANT from '@/components/html/14_The_everyday_world_is_what_quant'
 import HTML15_EVERYTHING_YOU_EXPERIENCE_IS_A from '@/components/html/15_Everything_you_experience_is_a'
 import HTML16_SCHR_DINGER_S_CAT_HAS_HAD_KITTEN from '@/components/html/16_Schr_dinger_s_cat_has_had_kitten'
 import HTML17_QUANTUM_MECHANICS_CAN_BE_HARNESS from '@/components/html/17_Quantum_mechanics_can_be_harness'
 import HTML18_QUANTUM_COMPUTERS_DON_T_NECESSAR from '@/components/html/18_Quantum_computers_don_t_necessar'
 import HTML19_THERE_IS_NO_OTHER__QUANTUM__YOU from '@/components/html/19_There_is_no_other__quantum__you'
 import HTML20_THINGS_COULD_BE_EVEN_MORE__QUANT from '@/components/html/20_Things_could_be_even_more__quant'
 import HTML21_THE_FUNDAMENTAL_LAWS_OF_QUANTUM from '@/components/html/21_The_fundamental_laws_of_quantum'
 import HTML22_CAN_WE_EVER_GET_TO_THE_BOTTOM_OF from '@/components/html/22_Can_we_ever_get_to_the_bottom_of'
 import HTML23_ACKNOWLEDGEMENTS from '@/components/html/23_Acknowledgements'
 import HTML24_NOTES from '@/components/html/24_Notes'
 import HTML25_BIBLIOGRAPHY from '@/components/html/25_Bibliography'
 import HTML26_INDEX from '@/components/html/26_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/03_Contents",
 			"name" : "html/03_Contents",
 			"component" : HTML03_CONTENTS
 		},
 		{
 			"path" : "/html/03_By_way_of_introduction",
 			"name" : "html/03_By_way_of_introduction",
 			"component" : HTML03_BY_WAY_OF_INTRODUCTION
 		},
 		{
 			"path" : "/html/04_No_one_can_say_what_quantum_mech",
 			"name" : "html/04_No_one_can_say_what_quantum_mech",
 			"component" : HTML04_NO_ONE_CAN_SAY_WHAT_QUANTUM_MECH
 		},
 		{
 			"path" : "/html/05_Quantum_mechanics_is_not_really",
 			"name" : "html/05_Quantum_mechanics_is_not_really",
 			"component" : HTML05_QUANTUM_MECHANICS_IS_NOT_REALLY
 		},
 		{
 			"path" : "/html/06_Quantum_objects_are_particle__bu",
 			"name" : "html/06_Quantum_objects_are_particle__bu",
 			"component" : HTML06_QUANTUM_OBJECTS_ARE_PARTICLE__BU
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js